import { SvgFactory } from '../../Svg';

const PencilIcon = SvgFactory(
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='black'>
        <path d='M2.99875 17.4615V20.5015C2.99875 20.7815 3.21875 21.0015 3.49875 21.0015H6.53875C6.66875 21.0015 6.79875 20.9515 6.88875 20.8515L17.8087 9.94152L14.0587 6.19152L3.14875 17.1015C3.04875 17.2015 2.99875 17.3215 2.99875 17.4615ZM20.7087 7.04152C21.0987 6.65152 21.0987 6.02152 20.7087 5.63152L18.3687 3.29152C17.9787 2.90152 17.3487 2.90152 16.9587 3.29152L15.1287 5.12152L18.8787 8.87152L20.7087 7.04152Z' />
    </svg>,
);

export default PencilIcon;
